"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ComposerHint.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _mentions = require('shared/services/mentions');
var _string = require('shared/services/string');
var _translation = require('shared/selectors/translation');
var _hooks = require('web/services/hooks');














/* "Spanish: <text>", or "Spanish: already in Spanish, sent as written". */
const previewLine = ({ Language, Text, Unchanged }) => {
  const name = _translation.languageName.call(void 0, Language)
  if (Unchanged) return `${name}: already in ${name}, sent as written`
  return `${name}: ${_optionalChain([Text, 'optionalAccess', _ => _.trim, 'call', _2 => _2()]) ? Text : 'preview unavailable'}`
}

/* "ⓘ Replies to Minh Tran are sent in Vietnamese · Preview" above the
 * message box, while the chat's replies are translated. Preview asks the
 * server once per click for the draft's translation per reply language (the
 * server keeps it, so sending the same draft reuses it); clicking again for
 * an unchanged draft shows the last answer without asking again. */
const ComposerHint = ({ conversationKey, draft, mentions }) => {
  const hint = _hooks.useAppSelector.call(void 0, state => _translation.selectComposerHint.call(void 0, state, conversationKey))
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const [result, setResult] = _react.useState(null)
  const inFlight = _react.useRef.call(void 0, false)
  const buttonRef = _react.useRef(null)
  const popoverId = _react.useId.call(void 0, )

  // The text a send would carry, so the server's saved preview is reused.
  const text = _react.useMemo.call(void 0, 
    () => mentions ? _mentions.normalizeMessageWithMentions.call(void 0, draft, mentions).text : draft,
    [draft, mentions],
  )
  const key = `${conversationKey}\0${_nullishCoalesce(hint, () => ( ''))}\0${text}`
  const isEmpty = _string.isBlank.call(void 0, draft)
  // A changed draft or hint closes an answer for the old one.
  const isShown = isOpen && !isEmpty && (isLoading || _optionalChain([result, 'optionalAccess', _3 => _3.key]) === key)

  const close = _react.useCallback.call(void 0, () => {
    setIsOpen(false)
    _optionalChain([buttonRef, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.focus, 'call', _6 => _6()])
  }, [])

  const onPreview = _react.useCallback.call(void 0, () => {
    if (inFlight.current) return
    if (isShown) {
      setIsOpen(false)
      return
    }
    setIsOpen(true)
    if (_optionalChain([result, 'optionalAccess', _7 => _7.key]) === key && !result.failed) return

    inFlight.current = true
    setIsLoading(true)
    _actions2.default.previewReplyTranslation({ ConversationKey: conversationKey, Text: text })
      .then(response => setResult({ key, previews: _nullishCoalesce(_optionalChain([response, 'optionalAccess', _8 => _8.Previews]), () => ( [])) }))
      .catch(() => setResult({ key, failed: true }))
      .finally(() => {
        inFlight.current = false
        setIsLoading(false)
      })
  }, [isShown, result, key, conversationKey, text])

  const onKeyDown = _react.useCallback.call(void 0, (event) => {
    if (event.key === 'Escape' && isShown) {
      event.stopPropagation()
      close()
    }
  }, [isShown, close])

  if (!hint) return null

  let body = null
  if (isShown) {
    if (isLoading) {
      body = _react2.default.createElement('p', { className: "composer-hint--status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, "Translating…")
    } else if (_optionalChain([result, 'optionalAccess', _9 => _9.failed]) || !_optionalChain([result, 'optionalAccess', _10 => _10.previews, 'optionalAccess', _11 => _11.length])) {
      body = _react2.default.createElement('p', { className: "composer-hint--status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}},  _translation.PREVIEW_UNAVAILABLE )
    } else {
      body = (
        _react2.default.createElement('ul', { className: "composer-hint--previews", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
          ,  result.previews.map(preview => (
            _react2.default.createElement('li', { key: preview.Language, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}},  previewLine(preview) )
          ))
        )
      )
    }
  }

  return (
    _react2.default.createElement('div', { className: "composer-hint", onKeyDown: onKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
      , _react2.default.createElement('span', { className: "composer-hint--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}, "ⓘ")
      , _react2.default.createElement('span', { className: "composer-hint--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}},  hint )
      , _react2.default.createElement('span', { className: "composer-hint--dot", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}, "·")
      , _react2.default.createElement('button', {
        ref: buttonRef,
        type: "button",
        className: "composer-hint--preview",
        'aria-expanded': isShown,
        'aria-controls': isShown ? popoverId : undefined,
        'aria-busy': isLoading,
        disabled: isEmpty || isLoading,
        onClick: onPreview, __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
, "Preview"

      )
      ,  isShown && (
        _react2.default.createElement('div', { id: popoverId, className: "composer-hint--popover", role: "dialog", 'aria-label': "Preview", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
          , _react2.default.createElement('div', { className: "composer-hint--popover--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
            , _react2.default.createElement('span', { className: "composer-hint--popover--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}, "Preview")
            , _react2.default.createElement('button', {
              type: "button",
              className: "composer-hint--popover--close",
              'aria-label': "Close preview" ,
              onClick: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
, "✕"

            )
          )
          , _react2.default.createElement('div', { 'aria-live': "polite", __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}},  body )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ComposerHint)
